import React, { useEffect, useState } from 'react';
import api from '../lib/api';

// Signed short-TTL download URL — works natively in <img src> and <a href>
// Falls back to path if already signed / external.
// export function useSignedUrl(url) {
//   const [signed, setSigned] = useState(null);
//   useEffect(() => {
//     if (!url) return;
//     if (!url.startsWith('/api/uploads/file/')) { setSigned(url); return; }
//     let cancelled = false;
//     api.get('/uploads/sign', { params: { path: url } })
//       .then((r) => { if (!cancelled) setSigned(r.data.signed_url); })
//       .catch(() => { if (!cancelled) setSigned(null); });
//     return () => { cancelled = true; };
//   }, [url]);
//   return signed;
// }

export function useSignedUrl(url) {
  const [signed, setSigned] = useState(null);

  useEffect(() => {
    if (!url) return;

    if (!url.startsWith('/api/uploads/file/')) {
      setSigned(url);
      return;
    }

    let cancelled = false;

    api.get('/uploads/sign', { params: { path: url } })
      .then((r) => {
        if (!cancelled) {
          // const apiUrl = import.meta.env.REACT_APP_BACKEND_URL || 'http://localhost:8002';
          const apiUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8002';
          setSigned(apiUrl + r.data.signed_url);
        }
      })
      .catch(() => {
        if (!cancelled) setSigned(null);
      });

    return () => {
      cancelled = true;
    };
  }, [url]);

  return signed;
}

export default function AuthImage({ url, alt = '', style, onClick }) {
  const signed = useSignedUrl(url);
  if (!signed) return <span style={{ width: (style?.width || 40), height: (style?.height || 30), background: 'var(--trello-list-bg)', display: 'inline-block', borderRadius: 3 }} />;
  return <img src={signed} alt={alt} style={style} onClick={onClick} />;
}

// Fire an async signed URL then open — used by <a> click handlers.
// export async function openAuthUrl(url, filename) {
//   if (!url.startsWith('/api/uploads/file/')) { window.open(url, '_blank', 'noopener'); return; }
//   try {
//     const r = await api.get('/uploads/sign', { params: { path: url } });
//     const win = window.open(r.data.signed_url, '_blank', 'noopener');
//     if (!win) alert('Please allow popups to download');
//   } catch (e) { alert('Failed to open file'); }
// }

// export async function openAuthUrl(url, filename) {
//   if (!url) return;

//   // External/already signed URL
//   if (!url.startsWith('/api/uploads/file/')) {
//     window.open(url, '_blank', 'noopener');
//     return;
//   }

//   try {
//     const { data } = await api.get('/uploads/sign', {
//       params: { path: url }
//     });

//     const apiUrl =
//       import.meta.env.REACT_APP_BACKEND_URL || 'http://localhost:8002';

//     const signedUrl = data.signed_url.startsWith('http')
//       ? data.signed_url
//       : `${apiUrl}${data.signed_url}`;

//     const win = window.open(signedUrl, '_blank', 'noopener');

//     if (!win) {
//       alert('Please allow popups to download');
//     }
//   } catch (err) {
//     console.error(err);
//     alert('Failed to open file');
//   }
// }
export async function openAuthUrl(url, filename) {
  try {
    let downloadUrl = url;

    if (url.startsWith('/api/uploads/file/')) {
      const { data } = await api.get('/uploads/sign', {
        params: { path: url }
      });

      const apiUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8002';
      // import.meta.env.REACT_APP_BACKEND_URL || 'http://localhost:8002';

      downloadUrl = data.signed_url.startsWith('http')
        ? data.signed_url
        : apiUrl + data.signed_url;
    }

    const response = await fetch(downloadUrl, {
      credentials: 'include'
    });

    if (!response.ok) {
      throw new Error('Download failed');
    }

    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = filename || 'download';
    document.body.appendChild(a);
    a.click();
    a.remove();

    window.URL.revokeObjectURL(blobUrl);
  } catch (err) {
    console.error(err);
    alert('Failed to download file');
  }
}